'use client';

import React, { useEffect, useRef, useState } from 'react';

interface AutoGrowingTextareaProps {
    value: string;
    minHeight: number;
    maxHeight: number;
    className?: string;
}

const AutoGrowingTextarea: React.FC<AutoGrowingTextareaProps> = ({ value, minHeight, maxHeight, className = '' }) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = `${minHeight}px`;
            const scrollHeight = textarea.scrollHeight;
            textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
        }
    }, [value, minHeight, maxHeight]);

    return (
        <textarea
            ref={textareaRef}
            className={`textarea textarea-bordered w-full overflow-auto ${className}`}
            style={{
                minHeight: `${minHeight}px`,
                maxHeight: `${maxHeight}px`,
                resize: 'none'
            }}
            value={value}
            readOnly
        />
    );
};

export default AutoGrowingTextarea;